import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";
import './modal_info_sanierungsfahrplan.css';

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';

export default function ModalInfoSanierungsfahrplan() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1>Was bedeutet individueller Sanierungsfahrplan?</h1>
            <p>Im individuellen Sanierungsfahrplan (iSFP) vorgeschlagene Maßnahmen erhalten die erhöhte BEG-Förderung von 20 %. Die für die Förderung ansetzbaren Kosten erhöhen sich von 30.000 € auf 60.000 € je Wohneinheit und Kalenderjahr.</p>
            <PanelImg src={"BEG-Einzelmassnahme_Beispielrechnung_EFH_250522.png"}/>
            {/* <table className="isptable" cellspacing="0" cellpadding="0" border="0"> 
            <tr>
                <th>förderfähige Investitionskosten je Wohneinheit</th>
                <th>ohne iSFP 15% Zuschuss</th>
                <th>mit iSFP 20% Zuschuss</th>
                <th>Förderplus mit iSFP</th>
            </tr>
            <tr>
                <td>10.000 €</td>
                <td>1.500 €</td>
                <td>2.000 €</td>		
                <td>500 €</td>
            </tr>
            <tr>
                <td>25.000 €</td>
                <td>3.750 €</td>
                <td>5.000 €</td>		
                <td>1.250 €</td>
            </tr>
            <tr>
                <td>30.000 €</td>
                <td>4.500 €</td>
                <td>6.000 €</td>		
                <td>1.500 €</td>
            </tr>
            <tr>
                <td>45.000 €</td>
                <td>4.500 €</td>
                <td>9.000 €</td>		
                <td>4.500 €</td>
            </tr>
            <tr>
                <td>50.000 €</td>
                <td>4.500 €</td>
                <td>10.000 €</td>		
                <td>5.500 €</td>
            </tr>
            <tr>
                <td>55.000 €</td>
                <td>4.500 €</td>
                <td>11.000 €</td>		
                <td>6.500 €</td>
            </tr>
            <tr>
                <td>max. 60.000 €</td>
                <td>4.500 €</td>
                <td>12.000 €</td>		
                <td>7.500 €</td>
            </tr>
            </table> */}
           
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

